import { useI18n } from '../context/I18nContext';

const SKILLS = [
  { key: 'beginner', labelKey: 'skillBeginner', icon: '🌱', descriptionKey: 'skillBeginnerDesc' },
  { key: 'professional', labelKey: 'skillProfessional', icon: '💼', descriptionKey: 'skillProfessionalDesc' },
  { key: 'expert', labelKey: 'skillExpert', icon: '🚀', descriptionKey: 'skillExpertDesc' }
];

export default function SkillSelectorModal({ onSelect }) {
  const { t } = useI18n();

  const handleSelect = (key) => {
    if (typeof onSelect === 'function') {
      onSelect(key);
    }
  };

  return (
    <div className="modal-overlay show" role="dialog" aria-modal="true" aria-labelledby="skill-title">
      <div className="modal skill-selector-modal">
        <div className="modal-header">
          <h2 id="skill-title">{t('selectYourSkill') || 'Select your Skill'}</h2>
        </div>
        <div className="modal-body">
          <p className="skill-selector-intro">
            {t('selectYourSkillDesc') || 'Choose your experience level to customize your interface.'}
          </p>
          <div className="skill-options">
            {SKILLS.map(skill => (
              <button
                key={skill.key}
                type="button"
                className="skill-option-card"
                onClick={() => handleSelect(skill.key)}
                onPointerDown={(e) => { e.preventDefault(); handleSelect(skill.key); }}
                onTouchStart={(e) => { e.preventDefault(); handleSelect(skill.key); }}
                aria-label={t(skill.labelKey) || skill.key}
              >
                <span className="skill-option-icon">{skill.icon}</span>
                <span className="skill-option-label">{t(skill.labelKey) || skill.key}</span>
                <span className="skill-option-desc">{t(skill.descriptionKey) || ''}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
